module.exports = __webpack_public_path__ + "img/47.5.COD.dbe35fb6.png";